import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line camelcase
import { JSON_parse } from 'uint8array-json-parser';
import { isBrowser } from 'utils/deploymentInfo';
import dispatchWorkRequest from 'utils/work/dispatchWorkRequest';
import waitForWorkRequest from 'utils/work/waitForWorkRequest';
import checkRequest from 'utils/work/checkRequest';
import inMemoryDownloader from 'utils/work/downloaders/inMemoryDownloader';
import isSignedUrlExpired from 'utils/work/isSignedUrlExpired';
var fetchWork = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(experimentId, body, getState, dispatch) {
    var optionals,
      downloader,
      parser,
      _optionals$extras,
      extras,
      _optionals$timeout,
      timeout,
      _optionals$broadcast,
      broadcast,
      _optionals$onETagGene,
      onETagGenerated,
      _optionals$onCachedRe,
      onCachedResultHit,
      _optionals$onWorkRequ,
      onWorkRequestSent,
      _optionals$fileName,
      fileName,
      requestProps,
      environment,
      _yield$checkRequest,
      cachedSignedUrl,
      ETag,
      cachedResult,
      request,
      _yield$waitForWorkReq,
      signedUrl,
      dataFromSocket,
      validSignedUrl,
      _yield$checkRequest2,
      refreshedSignedUrl,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          optionals = _args.length > 4 && _args[4] !== undefined ? _args[4] : {};
          downloader = _args.length > 5 && _args[5] !== undefined ? _args[5] : inMemoryDownloader;
          parser = _args.length > 6 && _args[6] !== undefined ? _args[6] : JSON_parse;
          _optionals$extras = optionals.extras, extras = _optionals$extras === void 0 ? undefined : _optionals$extras, _optionals$timeout = optionals.timeout, timeout = _optionals$timeout === void 0 ? 180 : _optionals$timeout, _optionals$broadcast = optionals.broadcast, broadcast = _optionals$broadcast === void 0 ? false : _optionals$broadcast, _optionals$onETagGene = optionals.onETagGenerated, onETagGenerated = _optionals$onETagGene === void 0 ? function () {} : _optionals$onETagGene, _optionals$onCachedRe = optionals.onCachedResultHit, onCachedResultHit = _optionals$onCachedRe === void 0 ? function () {} : _optionals$onCachedRe, _optionals$onWorkRequ = optionals.onWorkRequestSent, onWorkRequestSent = _optionals$onWorkRequ === void 0 ? function () {} : _optionals$onWorkRequ, _optionals$fileName = optionals.fileName, fileName = _optionals$fileName === void 0 ? undefined : _optionals$fileName;
          if (isBrowser) {
            _context.next = 6;
            break;
          }
          throw new Error('Disabling network interaction on server');
        case 6:
          requestProps = _objectSpread({
            broadcast: broadcast
          }, extras);
          environment = getState().networkResources.environment;
          _context.next = 10;
          return checkRequest(experimentId, body, requestProps, environment, fileName);
        case 10:
          _yield$checkRequest = _context.sent;
          cachedSignedUrl = _yield$checkRequest.signedUrl;
          ETag = _yield$checkRequest.ETag;
          onETagGenerated(ETag);
          _context.next = 16;
          return downloader({
            taskName: body.name,
            signedUrl: cachedSignedUrl,
            data: null,
            ETag: ETag,
            fileName: fileName,
            parser: parser
          });
        case 16:
          cachedResult = _context.sent;
          if (!cachedResult) {
            _context.next = 20;
            break;
          }
          onCachedResultHit({
            ETag: ETag,
            signedUrl: cachedSignedUrl
          });
          return _context.abrupt("return", cachedResult);
        case 20:
          onWorkRequestSent({
            ETag: ETag
          });
          _context.next = 23;
          return dispatchWorkRequest(experimentId, body, timeout, ETag, broadcast, fileName, dispatch);
        case 23:
          request = _context.sent;
          _context.next = 26;
          return waitForWorkRequest(ETag, experimentId, request, dispatch, parser);
        case 26:
          _yield$waitForWorkReq = _context.sent;
          signedUrl = _yield$waitForWorkReq.signedUrl;
          dataFromSocket = _yield$waitForWorkReq.data;
          validSignedUrl = signedUrl;
          if (!(!dataFromSocket && isSignedUrlExpired(validSignedUrl))) {
            _context.next = 36;
            break;
          }
          _context.next = 33;
          return checkRequest(experimentId, body, requestProps, environment, fileName);
        case 33:
          _yield$checkRequest2 = _context.sent;
          refreshedSignedUrl = _yield$checkRequest2.signedUrl;
          validSignedUrl = refreshedSignedUrl;
        case 36:
          _context.next = 38;
          return downloader({
            taskName: body.name,
            signedUrl: validSignedUrl,
            data: dataFromSocket,
            ETag: ETag,
            fileName: fileName,
            parser: parser
          });
        case 38:
          return _context.abrupt("return", _context.sent);
        case 39:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchWork(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export default fetchWork;